import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  email: string;
  followName?: string | null;
}

export function SendReportSuccessToast(props: Props) {
  const {
    id,
    email,
    followName,
  } = props

  const polyglot = usePolyglot()
  const body = followName ? polyglot.t(
    "toasts.send_report_success.follow_body",
    {
      followName,
      email,
    },
  ) : polyglot.t(
    "toasts.send_report_success.my_body",
    { email },
  )

  return (
    <Toast
      stylePreset="success"
      body={body}
      id={id}
    />
  )
}
